// Module
var code = "<template> <span if.bind=\"hasMultipleClinicalProducts\" class=\"pill ${productId | getProductPillClass}\"> ${productId | getProductName} </span> </template> ";
// Exports
export default code;